import { lazy } from 'react';

import { AppRoute } from '.';

const Login = lazy(() => import('../pages/auth/Login'));
const Sign = lazy(() => import('../pages/auth/Sign'));
const PasswordRecover = lazy(() => import('../pages/auth/PasswordRecover'));
const NewPassword = lazy(() => import('../pages/auth/NewPassword'));
const Activate = lazy(() => import('../pages/auth/Activate'));

const authRouter: AppRoute[] = [{
    path: '/login',
    component: Login,
    exact: true
}, {
    path: '/sign',
    component: Sign,
    exact: true
}, {
    path: '/activate',
    component: Activate,
    exact: true
}, {
    path: '/password-recover',
    component: PasswordRecover,
    exact: true
}, {
    path: '/new-password',
    component: NewPassword,
    exact: true
}];

export default authRouter;
